<template>
  <div>
    <div class="row mt-5">
        <div class="col-4"></div>
        <div class="col-4">
            <div class="container text-center">
                <div class="card" style="width: 18rem;">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">Id Agente: <b>{{ idAgente }}</b></li>
                        <li class="list-group-item">Poliza: <b>{{ poliza }}</b></li>
                        <li class="list-group-item">Renovacion: <b>{{ renov }}</b></li>
                        <li class="list-group-item">Ramo: <b>{{ ramo }}</b></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-4"></div>
    </div>
    
    
  </div>
</template>

<script>

export default {
  data() {
    return {
        idAgente: this.$route.params.idAgente,
        poliza: this.$route.params.poliza,
        renov: this.$route.params.renov,
        ramo: this.$route.params.ramo,
    };
  },
  methods: {
    getParamsURL() {
        console.log(this.idAgente);
        console.log(this.poliza);
        console.log(this.renov);
        console.log(this.ramo);
    }
  },
  mounted() {
    this.getParamsURL();

  }
}
</script>

<style>

</style>